import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';

@Component({
  selector: 'app-generic-field',
  templateUrl: './generic-field.component.html',
  styleUrls: ['./generic-field.component.scss']
})
export class GenericFieldComponent implements OnInit {
  @Input() rowSpan: number = 1;
  @Input() hideLabel: boolean = false;
  @Input() label: string;

  containerStyle: SafeStyle;

  constructor(public domSanitizer: DomSanitizer) { }

  ngOnInit(): void {
    const containerHeight = (this.rowSpan * 50);
    const containerStyle = `height: ${containerHeight}px;`;
    this.containerStyle = this.domSanitizer.bypassSecurityTrustStyle(containerStyle);
  }

}
